import { G_APP_NAME } from "@/constants";

export const translationsEn = {
  lmMainBrandName: G_APP_NAME,
  appVersionTitle: "Version",
  appMaxCanvasTitle: "Canvas factor",
  appMaxCanvasSize: "Max canvas size",
  appErrorTitle: "Error",
  appWarningTitle: "Warning",
  // COUNTRIES
  cSloveniaName: "Slovenia",
  cCroatiaName: "Croatia",
  // DAYSOFWEEK
  dayMonday: "monday",
  dayTuesday: "tuesday",
  dayWednesday: "wednesday",
  dayThursday: "thursday",
  dayFriday: "friday",
  daySaturday: "saturday",
  daySunday: "sunday",
  // MONTHS
  yearStr: "Year",
  monthStr: "Month",
  monthJanuary: "January",
  monthFebruary: "February",
  monthMarch: "March",
  monthApril: "April",
  monthMay: "May",
  monthJune: "June",
  monthJuly: "July",
  monthAugust: "August",
  monthSeptember: "September",
  monthOctober: "October",
  monthNovember: "November",
  monthDecember: "December",
  // BUTTONS COMMON
  lmBtnRemove: "Remove",
  lmBtnPreview: "Preview",
  lmBtnDelete: "Delete",
  lmBtnCrop: "Crop",
  lmBtnCropAgain: "Crop again",
  lmBtnReset: "Reset",
  lmBtnApply: "Apply",
  lmBtnCancel: "Cancel",
  lmBtnSelect: "Select",
  lmBtnDesign: "Design",
  lmBtnSend: "Send",
  lmBtnAdd: "Add",
  lmBtnAddBatch: "Add batch",
  lmBtnClose: "Close",
  lmBtnSave: "Save",
  lmBtnBack: "Back",
  lmBtnNext: "Next",
  lmBtnConfirm: "Confirm",
  lmBtnReply: "Reply",
  lmBtnNewMessage: "New message",
  lmBtnSignOut: "Sign out",
  lmBtnAgree: "I agree",
  lmBtnYes: "Yes",
  lmBtnNo: "No",
  lmBtnAllow: "Allow",
  lmStep: "Step",
  lmPleaseWait: "Please wait ...",
  lmPcs: "pcs",
  lmDays: "days",
  lmMax: "max",
  lmWidthCustomSize: "Width in cm (6 or 7.8)",
  lmHeightCustomSize: "Height in cm (6 or 7.8)",
  lmLastDay: "Last day",
  msgConfirm: "Confirm",
  msgQuestion: "Question",
  msgAdvice: "Tip",
  msgError: "Error",
  msgAddedTitle: "added",
  msgHelpTitle: "Help",
  msgMore: "More",
  msgUnderstand: "Got it",
  msgSet: "Set",
  msgShow: "Show",
  msgAll: "All",
  msgShowAll: "Show all",
  msgSelectAll: "Select all",
  msgSelectDoneOlder: "Select completed (7days+)",
  msgDeselectAll: "Clear selection",
  msgEditText: "Enter text",
  msgNoText: "<empty>",
  msgPage: "Page",
  settingsNotifyEmailText:
    "Notification email(s), more than one separate with ;",
  msgRecordLastAddedEdited: "Created / Last edit",
  msgInventory: "Inventory",
  msgInventoryLastPcs: "Last items",
  msgInventoryLastPiece: "Last item",
  msgInventorySoldOut: "Currently not available",
  msgInventoryAvailable: "In stock",
  fileNamePackageImages: "Images", // za v ime zip fajla, ne sme biti presledkov
  fileNamePackageItems: "Items", // za v ime zip fajla, ne sme biti presledkov
  askSimpleImageDelete: "Are you sure you want to delete this image?",
  warningEnableSmallDevices:
    "Designing this item is only allowed on personal computers, due to the size of the template. Thank you.",
  errorGeneratingGiftImages:
    "Low memory error while generating images. Package was not uploaded.",
  // DIALOG PIXABAY IMAGE DATABASE SELECTION
  dialogPixabayImageTypeAll: "All types",
  dialogPixabayImageTypeImages: "Images",
  dialogPixabayImageTypeIllustrations: "Illustrations",
  dialogPixabayImageTypeVectors: "Vectors",
  dialogPixabayImageOrientationAll: "All orientations",
  dialogPixabayImageOrientationLandscape: "Landscape",
  dialogPixabayImageOrientationPortrait: "Portrait",

  dialogPixabayImageCategoryAll: "All categories",
  dialogPixabayImageCategoryBackgrounds: "Backgrounds",
  dialogPixabayImageCategoryNature: "Nature",
  dialogPixabayImageCategoryFeelings: "Feelings",
  dialogPixabayImageCategoryAnimals: "Animals",
  dialogPixabayImageCategoryFashion: "Fashion",
  dialogPixabayImageCategoryMusic: "Music",
  dialogPixabayImageCategorySports: "Sports",
  dialogPixabayImageCategoryScience: "Science",
  dialogPixabayImageCategoryEducation: "Education",
  dialogPixabayImageCategoryHealth: "Health",
  dialogPixabayImageCategoryPeople: "People",
  dialogPixabayImageCategoryReligion: "Religion",
  dialogPixabayImageCategoryPlaces: "Places",
  dialogPixabayImageCategoryIndustry: "Industry",
  dialogPixabayImageCategoryComputer: "Computers",
  dialogPixabayImageCategoryFood: "Food",
  dialogPixabayImageCategoryTransportation: "Transportation",
  dialogPixabayImageCategoryTravel: "Travel",
  dialogPixabayImageCategoryBuildings: "Buildings",
  dialogPixabayImageCategoryBusiness: "Business",

  dialogPixabayImageColorAll: "All colors",
  dialogPixabayImageColorGrayscale: "Grayscale",
  dialogPixabayImageColorRed: "Red",
  dialogPixabayImageColorOrange: "Orange",
  dialogPixabayImageColorYellow: "Yellow",
  dialogPixabayImageColorGreen: "Green",
  dialogPixabayImageColorTurquoise: "Turquoise",
  dialogPixabayImageColorBlue: "Blue",
  dialogPixabayImageColorLilac: "Lilac",
  dialogPixabayImageColorPink: "Pink",
  dialogPixabayImageColorWhite: "White",
  dialogPixabayImageColorGray: "Gray",
  dialogPixabayImageColorBlack: "Black",
  dialogPixabayImageColorBrown: "Brown",
  // DIALOG IMAGE DATABASE SELECTION
  dialogImageDatabaseSelectionOrderBy: "Show",
  dialogImageDatabaseSelectionOrderByAddition: "newest first",
  dialogImageDatabaseSelectionOrderByPopularity: "popular first",
  dialogImageDatabaseSelectionStickersType: "Sticker type",
  dialogImageDatabaseSelectionStickersTypeAll: "All stickers",
  dialogImageDatabaseSelectionStickersTypeImages: "Image stickers",
  dialogImageDatabaseSelectionStickersTypeLang: "English text stickers",
  dialogImageDatabaseSelectionStickersTypeCurrentLang:
    "Text stickers in my language",
  dialogImageDatabaseSelectionStickersTypeCustomBtn: "Import",
  dialogImageDatabaseSelectionStickersTypeCustomBtnLong:
    "Import my own sticker",
  // FABRIC CONTROLS
  fabricAddTextButton: "Text",
  fabricAddImageButton: "Image",
  fabricChangeTemplateButton: "Template",
  fabricChangeTemplateDialogTitle: "Change template",
  fabricSelectTemplateDialogTitle: "Select template",
  fabricSelectStickerDialogTitle: "Select sticker",
  fabricSelectImageBackgoundDialogTitle: "Select background",
  fabricImageFilterBase: "Image filter",
  fabricImageFilterGrayscale: "Grayscale",
  fabricImageFilterVintage: "Vintage",
  fabricImageFilterBrownie: "Brownie",
  fabricImageFilterSephia: "Sephia",
  fabricImageFilterKodachrome: "Kodachrome",
  fabricImageFilterNoFilter: "no filter",
  fabricColorPickerTitle: "Select color",
  fabricDialogPreviewTitle: "Preview",
  fabricDialogPreviewOnItemTitle: "Preview on item",
  fabricDialogPreviewImageTitle: "Your image",
  fabricColorPickerActivateGradientTitle: "Create gradient color",
  fabricBackgroundImageGroupControlsBackTitle: "back",
  fabricBackgroundImageGroupControlsMenuTitle: "menu",
  fabricBackgroundImageGroupControlsTitle: "background filters",
  fabricImageFiltersGroupControlsTitle: "image filters",
  fabricElementsGroupControlsTitle: "add element",
  fabricBackgroundGroupControlsTitle: "slika",
  fabricBackgroundGroupControlsBackgroundTitle: "background",
  fabricZoomGroupControlsTitle: "zoom",
  fabricZoomGroupControlsSubTitle: "set",
  fabricImageGroupControlsTitle: "image",
  fabricPreviewGroupControlsTitle: "preview",
  fabricBorderGroupControlsTitle: "border",
  fabricTextOutlineGroupControlsTitle: "outline",
  fabricRadiusGroupControlsTitle: "radius",
  fabricSimpleFrameGroupControlsTitle: "frame",
  fabricTextStyleGroupControlsTitle: "style & background",
  fabricBackgroundImageAddImageTitle: "My background image",
  fabricBackgroundImageAddCollageTitle: "Add multiple images to collage",
  fabricBackgroundImageAddBackgroundTitle: "Select background image",
  fabricBackgroundImageAddPixabayBackgroundTitle: "Pixabay background image",
  fabricBackgroundImageAddPixabayPatternTitle: "Pixabay seamless pattern",
  fabricBackgroundImageAddPatternTitle: "Select background pattern",
  fabricBackgroundImageAddFrameTitle: "Select frame",
  fabricBackgroundImageAddColorTitle: "Select background color",
  fabricBackgroundImageResetBackgroundTitle: "Remove background",
  fabricBackgroundImageStartBackgroundTitle: "Original background",
  fabricBackgroundImageShowFilters: "Background filters",
  fabricZoomBackTitle: "back",
  fabricZoomEditBackTitle: "edit",
  fabricZoomMainControlsTitle: "zoom level",
  fabricZoomMainControlsInTitle: "zoom in",
  fabricZoomMainControlsOutTitle: "zoom out",
  fabricZoomMainControlsDefaultTitle: "reset",
  fabricFreeDrawingApply: "apply",
  fabricFreeDrawingCancel: "cancel",
  fabricFreeDrawingBrush: "brush",
  fabricFreeDrawingShadow: "shadow",
  fabricTextFont: "font",
  fabricTextFunction: "Text type",
  fabricTextFunctionNormal: "Normal text",
  fabricTextFunctionGiftCardFull: "Gift card (title code | title price | title valid to)",
  fabricTextFunctionGiftCardFullShort: "Gift card (code | price | valid to)",
  fabricTextFunctionGiftCardCodeValidTo: "Gift card (title code | title valid to)",
  fabricTextFunctionGiftCardCodeValidToShort: "Gift card (code | valid to)",
  fabricTextFunctionGiftCardFullCode: "Gift card (title code)",
  fabricTextFunctionGiftCardFullPrice: "Gift card (title price)",
  fabricTextFunctionGiftCardFullValidTo: "Gift card (title valid to)",
  fabricTextFunctionGiftCardCode: "Gift card (code)",
  fabricTextFunctionGiftCardPrice: "Gift card (price)",
  fabricTextFunctionGiftCardPriceOnly: "Gift card (price only)",
  fabricTextFunctionGiftCardValidTo: "Gift card (valid to)",
  fabricTextFunctionGiftCardUserCode: "Code",
  fabricTextFunctionGiftCardUserPrice: "Value",
  fabricTextFunctionGiftCardUserPriceOn: "show",
  fabricTextFunctionGiftCardUserPriceOff: "hide",
  fabricTextFunctionGiftCardUserValidTo: "Valid to",
  fabricAllowDelete: "Allow delete",
  fabricAllowManipulate: "Allow manipulation",
  fabricAllowReplace: "Replace category",
  fabricAllowEdit: "Allow edit",
  fabricRemoveOverlay: "Remove on finish",
  fabricPreviewImage: "image",
  fabricPreviewItem: "item",
  fabricPreviewBackground: "select",
  fabricAddImage: "frame",
  fabricAddFrame: "Add image with an advanced frame",
  fabricAddSimpleFrame: "Add image in a simple square frame",
  fabricAddSimpleFrame2: "Add image in a simple round frame",
  fabricAddCollage: "Add multiple images to collage",
  fabricAddSticker: "sticker",
  fabricAddText: "text",
  fabricAddFree: "drawing",
  fabricFiltersFilter: "filter",
  fabricFiltersBrightness: "bright.",
  fabricFiltersBlur: "blur",
  fabricFiltersContrast: "contrast",
  fabricFiltersReset: "reset",
  fabricTextOutlineWidth: "width",
  fabricTextOutlineColor: "color",
  fabricTextFontName: "font",
  fabricTextFontColor: "color",
  fabricTextMagicStyle: "style",
  fabricTextStyleAlign: "alignment",
  fabricTextStyleBackgroundColor: "backg.",
  fabricFreeHandChanges: "changes",
  // FLAG SELECTION
  lmFlagSelectBtnTitle: "Language",
  // FORM VALIDATION COMMON
  frmValidationRequiredField: "This field is required",
  frmValidationStringTooLongField: "String is too long",
  frmValidationNumberTooBigField: "Number is too big",
  frmValidationNotCurrencyField: "Enter amount (4 or 3.50 etc.)",
  frmValidationNotPctField: "Enter percent amount between 0 and 999",
  frmValidationNotNumberField: "Enter valid number",
  // DATA GRID COMMON
  dataGridRowPage: "Page",
  dataGridRowsPerPageText: "Rows per page",
  dataGridRowsPerPageAllText: "All",
  dataGridRowsPageText: "of",
  dataGridSearchLabel: "Search",
  dataGridPixabaySearchLabel: "Enter one ore more words",
  dataGridSlotNoData: "No data to display.",
  dataGridSlotNoResults: "No records matching your search.",
  // ADD EDIT FORM COMMON
  addEditFormAddingTitle: "Add record",
  addEditFormEditingTitle: "Edit record",
  addEditFormSaveButton: "Save",
  addEditFormCloseButton: "Close",
  addEditFormBackButton: "Back",
  addEditFormCancelButton: "Cancel",
  // DIALOGCUSTOMSIZE
  dialogCustomSizeTitle: "Enter image dimensions",
  dialogCustomSizeZeroError: "Width and height must be greater than 0.",
  // DIALOG COMMON
  deleteDialogTitle: "Delete record",
  deleteDialogQuestion: "Are you sure you want to delete this record?",
  deleteDialogImageQuestion: "Are you sure you want to delete this image?",
  deleteDialogQuestionWarning:
    "WARNING! Deleting this record will also remove all connected records.",
  deleteDialogQuestionWarning2:
    "WARNING! This record is connected to other data tables. Deleting this record will break active underlying record connections.",
  // COMMON MESSAGES
  msgSuccessSaveRefresh: "Saved. Changes will apply after application reload.",
  msgSuccessDelete: "Record deleted.",
  msgActionError: "Action failed to complete.",
  msgSuccessImageDelete: "Image deleted.",
  msgErrorImageDelete: "Image was not deleted.",
  msgSuccessEdit: "Record edited and saved.",
  msgSuccessAdd: "Record added.",
  msgErrorSave: "Error saving data.",
  msgSelectPicture: "Select picture",
  msgPropUpdateText: "Edit",
  msgWelcomeText: "Welcome",
  msgNotification: "Notification",
  // FORM COMMON
  lmFrmEmail: "E-mail",
  lmFrmDisplayName: "Display name",
  lmFrmErrorRequiredField: "This field is required",
  lmFrmErrorFormatField: "This data is not valid",
  lmFrmErrorWidthLessThanHeightField:
    "Width has to be greater or equal to image height (landscape orientation)",
  lmFrmErrorMaxCustomSizeField:
    "Your image dimensions are too big. Please enter different size.",
  lmFrmErrorFormatPasswordField: "Minimum password length is 5 characters",
  lmFrmEnterEmail: "Enter your email address",
  lmFrmEnterPass: "Enter your password",
  lmFrmEnterPassError: "Your password is not correct.",
  // FORM LOGIN
  lmSignInMainTitle: G_APP_NAME + " / Login",
  lmSignInWithGoogleBtn: "Gmail",
  lmSignInWithFacebookBtn: "Facebook",
  lmSignInWithClassicBtn: "Classic",
  lmSignInLoginBtn: "Login",
  lmSignInForgottenPass: "Forgotten password?",
  lmSignInNewUser: "Create new user",
  lmSignInResetPassword: "Link for password reset was sent to your email.",
  lmSignInWelcomeMessage:
    "Welcome to online store. Please, select one of the login options.",
  lmSignInLoadingMessage: "Please wait while logging ...",
  lmSignInCookieNotifyMessage:
    "This page uses cookies to enable you the best possible user experience and content quality.",
  lmSignInCookieAgreeBtn: "I agree",
  lmSignInFacebookInfo:
    "You are currently inside Facebook or Inastagram browser, but this app requires your default web browser to run properly.",
  lmSignInFacebookInfo2:
    "Please click in the upper right corner on three dotted line and select 'Open in ...' from dropdown menu. Thank you.",
  lmSignInPrivacyLinkTitle: "Safety and security",
  lmSignInRulesLinkTitle: "Terms of use",
  // FORM SIGNUP
  lmSignUpMainTitle: G_APP_NAME + " / New user",
  lmSignUpBackToLogin: "Back to login",
  lmSignUpConfirmBtn: "Create account",
  // TOOLBAR MENU USER PROFILE
  lmToolbarUserMenuItemEditSettings: "Edit user data",
  lmToolbarUserMenuItemLogout: "Signout",
  // TODO.VUE
  lmTodoMainTitle: "TODOS",
  lmTodoWhatTodo: "What needs to be done?",
  lmTodoFilterAll: "all",
  lmTodoFilterActive: "active",
  lmTodoFilterDone: "done",
  lmTodoItemsLeft: "items left",
  lmTodoClearCompleted: "Clear completed",
  // DASHBOARD.VUE
  dashboardCardAdminSectionTitle: "Control panel",
  dashboardCardAdminSectionSubTitle: "Manage orders and settings.",
  dashboardCardModulePhotoOrderTitle: "Orders",
  dashboardCardModulePhotoOrderUserTitle: "Your memories",
  dashboardCardModulePhotoOrderUserSubTitle:
    "Developing prints from all devices",
  dashboardCardModulePhotoGiftTitle: "Give sometnig special",
  dashboardCardModulePhotoGiftSubTitle: "Photo products",
  dashboardCardModuleExtraCostSubTitle: "Extra costs",
  dashboardCardModulePhotoOrderUserOrderButtonTitle: "Create new order",
  dashboardCardModulePhotoGiftOrderButtonTitle: "Order products",
  dashboardCardModulePhotoOrderPricesButtonTitle: "Prices",
  dashboardCardAddClientSuperAdminTitle: "Stores",
  dashboardCardActionsDiscountsTitle: "Discount codes",
  dashboardCardSuperAdminTitle: "Settings",
  dashboardCardSuperAdminSubTitle: "Detailed store settings",
  dashboardCardSuperAdminDelivery: "Pickup places",
  dashboardCardSuperAdminGiftCardTemplate: "Gift card templates",
  dashboardCardSuperAdminGiftCardActive: "Active gift cards",
  dashboardCardSuperAdminGiftCardCategory: "Gift card categorys",
  dashboardCardSuperAdminPromoCodes: "Promotinal codes",
  dashboardCardSuperAdminImageTemplate: "Image templates",
  dashboardCardSuperAdminBasicSettings: "Card settings",
  dashboardCardSuperAdminColors: "Color theme",
  dashboardCardSuperAdminImageSizes: "Image sizes",
  dashboardCardSuperAdminImageDiscounts: "Bulk discounts",
  dashboardCardSuperAdminPaperType: "Paper types",
  dashboardCardSuperAdminUserRights: "User rights",
  dashboardCardSuperAdminOther: "Store settings",
  dashboardCardSuperAdminProducts: "Products",
  dashboardCardSuperAdminProductsCategory: "Products categories",
  dashboardCardSuperAdminAppStatistics: "Statistics",
  dashboardCardSuperAdminPhotoGiftCategory: "Photo gift categories",
  dashboardCardSuperAdminPhotoGiftSuperCategory: "Super categories",
  dashboardCardSuperAdminPhotoGift: "Products",
  dashboardCardSuperAdminBackgroundsCatDatabase: "Background categorys",
  dashboardCardSuperAdminBackgroundsDatabase: "Backgrounds",
  dashboardCardSuperAdminPatternsCatDatabase: "Pattern categorys",
  dashboardCardSuperAdminPatternsDatabase: "Patterns",
  dashboardCardSuperAdminFramesCatDatabase: "Frame categorys",
  dashboardCardSuperAdminFramesDatabase: "Frames",
  dashboardCardSuperAdminStickersCatDatabase: "Sticker categorys",
  dashboardCardSuperAdminStickersDatabase: "Stickers",
  dashboardCardUserSettingsTitle: "User settings",
  dashboardCardUserSettingsSubTitle: "Here you can update your user data.",
  dashboardCardUserSettingsUpdateProfileWarning:
    "Please update your profile data",
  dashboardCardUserSettingsSubTitleUnknownUser: "Unknown user",
  dashboardCardUserSettingsUpdateButtonTitle: "Update profile",
  dashboardCardUserOrdersTitle: "Orders",
  dashboardCardUserNewOrderTitle: "New order",
  dashboardCardAdminActivePackagesViewTitle: "All delivery units",
  // HOMEMENUACTIVEPROMOTIONS.VUE
  homeMenuActivePromotionsPart1Text: "Use code",
  homeMenuActivePromotionsPart2Text: "and save",
  homeMenuActivePromotionsPart3Text: " on your prints order",
  homeMenuActivePromotionsPart3bText: " on your photo products order",
  homeMenuActivePromotionsPart3cText: " on your photo product",
  homeMenuActivePromotionsPart3dText: " on your photo products from category",
  homeMenuActivePromotionsPart3aText: " on your whole order",
  homeMenuActivePromotionsPart4aText: " This is a one time valid code.",
  homeMenuActivePromotionsPart4bText: " This code can be used multiple times.",
  // USERORDERS.VUE
  userOrdersEmptyMsg: "You have no active orders.",
  userOrdersCancelOrderBtn: "Cancel order",
  userOrdersCancelOrderQuestion: "Are you sure you want to cancel order ",
  userOrdersCloseOrderBtn: "I already received this order",
  userOrdersCloseOrderSucess: "This order was removed from active orders.",
  userOrdersCloseOrderError: "Error removing this order.",
  userOrdersStatus0Title: "Waiting",
  userOrdersStatus1Title: "Developing",
  userOrdersStatus2Title: "Done",
  userOrdersStatus3Title: "Closed",
  userOrdersStatus3aTitle: "Delivered",
  userOrdersStatus3bTitle: "Mailed",
  userOrdersPackagesList: "Order details",
  userOrdersDisplayList: "Show",
  userOrdersNewSearchList: "Search",
  userOrdersNewSearchList2: "Search orders",
  userOrdersUserDataList: "User personal info",
  userOrdersAdminWorkList: "Work status",
  userOrdersMessages: "Message for studio",
  userOrdersDateViewLast7: "Last 7 days",
  userOrdersDateViewLast30: "Last 30 days",
  userOrdersDateViewLast90: "Last 90 days",
  userOrdersDateYear: "Year",
  userOrdersCustomSearch: "Search for specific order",
  userOrdersModPhotoOrderSummary: "Photo order summary",
  userOrdersModPhotoGiftSummary: "Photo products summary",
  userOrdersFullSummary: "Final price",
  userOrdersIncludesTax: "All prices include",
  userOrdersPayedFullSummary: "Order value",
  userOrdersSendEmailSubject: "New order",
  userOrdersSendEmailPrepaySubject: "prepay",
  userOrdersSendEmailReferenceSubject: "Prepay reference",
  userOrdersCompleteSendEmailSubject: "Your order",
  userOrdersCompleteSendEmailSubject2: "is ready!",
  userOrdersMessageForStudio: "Message for studio",
  userOrdersSendEmailPrepayHeaderTitle: "Information for payment",
  userOrdersTotalNum: "Total orders",
  userOrdersTotalSum: "Total sum",
  // HOMEMENUADMINSTATS
  homeMenuAdminStatsMainTitle: "Fast statistics",
  homeMenuAdminStatsTodayTitle: "Today",
  homeMenuAdminStatsLastDaysTitle: "Last 7 days",
  homeMenuAdminStatsLastMonthTitle: "This month",
  homeMenuAdminStatsNoGraphTitle: "Graph will be available tomorrow.",
  homeMenuAdminStatsCurrentSubscriptionAmountTitle:
    "This month's subscription fee is",
  // HOMEMENUADMINPACKAGES
  homeMenuAdminPackagesTemporaryPackages: "Backup package links",
  homeMenuAdminPackagesMultipleRecipients: "Multiple recipients",
  homeMenuAdminPackagesBtnDoneSelection: "Tag as done",
  homeMenuAdminPackagesBtnDeliveredSelection: "Tag as delivered",
  homeMenuAdminPackagesSelection: "Elements selected",
  homeMenuAdminPackagesNoMessages: "No messages.",
  homeMenuAdminPackagesSendExtraEmailStudio: "Message about your order",
  homeMenuAdminPackagesSendExtraEmailMsg1: "This message is computer generated, so don't reply to it! If you wish to reply, login to our app and go to Orders. Then click on your order to view the details and click New message button.",
  homeMenuAdminPackagesSendExtraEmail: "Send extra email",
  homeMenuAdminPackagesSendExtraEmailRecipient: "Naslovnik",
  homeMenuAdminPackagesCustomer: "Customer",
  homeMenuAdminPackagesEmptyMsg: "Currently there are no new or open orders.",
  homeMenuAdminPackagesNotificationQuestionWarningTitle:
    "When the order is marked DONE, image packages of this order will be permanently deleted.",
  homeMenuAdminPackagesNotificationQuestionTitle:
    "Notify customer about the completed order?",
  homeMenuAdminPackagesDeleteFromStorageTitle:
    "When the order is closed, all the information about this order will be archived, but image packages will be permanently deleted.",
  homeMenuAdminPackagesInternalNoteTitle: "Add internal note to this order",
  homeMenuAdminPackagesInternalNoteDeleteTitle: "Delete internal note",
  homeMenuAdminPackagesInternalNoteDeleteBodyTitle: "Are you sure you want to delete this internal note?",
  // HOMEMENUCARTINFO.VUE
  homeMenuCartInfoEmpty: "Your shopping cart is empty.",
  homeMenuCartInfoCartTitle: "Cart",
  homeMenuCartInfoCashierTitle: "Cashier",
  homeMenuCartInfoOrderStatusTitle: "Orders",
  homeMenuCartInfoAddImagesTitle: "Add more images",
  homeMenuCartInfoActiveModeratorsTitle: "Today with you",
  homeMenuCartInfoActiveUserRoomsTitle: "Customer chats",
  homeMenuCartInfoFirstMessageTitle: "Hi, how can I help you today?",
  homeMenuCartInfoSendEmailTitle: "Please write your message",
  homeMenuCartInfoSendMessageTitle: "Write your message ...",
  homeMenuCartInfoSendEmailSuccessTitle: "Message was sent successfully.",
  homeMenuCartInfoSendMsgSuccessTitle: "Message was added successfully.",
  homeMenuCartInfoRemoveMsgSuccessTitle: "Message was removed successfully.",
  homeMenuCartInfoRemoveMsgErrorTitle: "Message was not removed.",
  homeMenuCartInfoSendMsgErrorTitle: "Message was not added.",
  homeMenuCartInfoSendEmailErrorTitle:
    "There was an error while sending your message.",
  homeMenuCartInfoSendEmailSubjectTitle: "APP | Message from: ",
  homeMenuCartInfoCancelOrderEmailSubjectTitle: "Order cancelation: ",
  homeMenuCartInfoCancelOrderEmailSubjectBody1: " canceled order nr. ",
  homeMenuCartInfoCloseChatButtonTitle: "End conversation",
  homeMenuCartInfoActionButtonWelcomeTitle: "How can we help you today?",
  // HOMEMENUADMINARCHIVE
  homeMenuAdminArchiveTitle: "Orders archive",
  homeMenuAdminArchiveViewTitle: "Search",
  homeMenuAdminArchiveViewSearchStrTitle: "Enter search string",
  homeMenuAdminArchiveSearchType: "Search type",
  homeMenuAdminArchiveSearchNoResults:
    "No orders in the archive with this data.",
  homeMenuAdminArchiveSearchByOrderId: "Order Id",
  homeMenuAdminArchiveSearchByFullName: "Customer name",
  homeMenuAdminArchiveSearchByEmail: "Customer email",
  // GIFTCARD
  giftCardNewAdded: "Gift card was added from an order.",
  giftCardCodeTitle: "Code",
  giftCardFullNameTitle: "Full name",
  giftCardAddress1Title: "Street number",
  giftCardAddress2Title: "Post number / Post",
  giftCardCountryTitle: "Country",
  giftCardEmailTitle: "Email",
  giftCardPhoneTitle: "Phone",
  giftCardNotesTitle: "Notes",
  giftCardValueTitle: "Value",
  giftCardClosedTitle: "Closed",
  giftCardItemNameTitle: "Card type",
  giftCardValidToTitle: "Valid to",
  giftCardAddedDateTitle: "Added",
  giftCardCloseCardQuestionTitle: "Are you sure, that you want to close this guft card?",
  // USERCART.VUE
  userCartDetailsTitle: "Cart item details",
  userCartModPhotoOrdersTitle: "Photo prints",
  userCartModPhotoOrdersMinOrderError: "Minimal prints order amount is",
  userCartModPhotoOrdersMinOrderError2: ". If you want to finish your order, you have to add more images.",
  userCartModPhotoOrderPackageTitle: "Image package",
  userCartModPhotoOrderAddMore1Title: "Add",
  userCartModPhotoOrderAddMore2Title: "photos and save extra",
  userCartModPhotoGiftAddMore2Title: "products and save extra",
  userCartModPhotoGiftTitle: "Photo products",
  userCartModPhotoGiftPackageTitle: "Product",
  userCartStorageDeletionNotification:
    "Your packages will be stored for 7 days. Then they will be removed.",
  // USERCASHIER.VUE
  userCashierDeliveryTitle: "Delivery type",
  userCashierDeliveryTypeTitle: "Payment type",
  userCashierDeliveryTypePersonalTitle: "In the store",
  userCashierDeliveryTypePrepayTitle: "Bank prepayment",
  userCashierDeliveryTypeAtDeliveryTitle: "At delivery",
  userCashierDeliveryTypeCardTitle: "Credit card",
  userCashierEditUserProfileTitle:
    "Please update your missing user profile information.",
  userCashierDeliveryTypePrepayInfoTitle:
    "You will receive prepay information on your email. Your order will be developed after your payment is received.",
  userCashierDeliveryTypeAtDeliveryInfoTitle:
    "Your order will be sent with payment at delivery. This can cause additional costs for you (delivery payment provision) despite being charged for delivery here. This costs have to be paid by you. If you don't agree with that, please select other payment option.",
  userCashierFinalSumTitle: "Final charge",
  userCashierAddItemsTitle: "Add items",
  userCashierFinishOrderTitle: "Finish order",
  userCashierFinalSumNullTitle: "Error while calculationg the value of this order. Please go back to the cart and try again.",
  userCashierAddressAndPhoneDataTitle: "Delivery and notification details",
  userCashierPhoneDataTitle: "Notification details",
  userCashierMsgConfirm:
    "Please confirm your order placemet. You can track your orders in the app (orders), but you will be notified via email or phone when your order is complete. Thank you for your order.",
  msgSuccessAddOrder: "Your order was sent successfully.",
  userCashierAddMore1Title: "Add items for",
  userCashierAddMore2Title: "and get a discount of",
  userCashierOrderIdTitle: "Order ID",
  userCashierEmailNewOrderStart:
    "<p>Dear customer, thank you for your order. You will be notified when your order is ready.</p>",
  userCashierEmailNewOrderPrepayStart:
    "<p>Dear customer, thank you for your order. When you pay this prepay, your order will be processed. You will be notified when your order is ready. To speed this process up, you can send us proof of payment at [email].</p>",
  userCashierEmailOrderCompletedPersonalDelivery:
    "<p>Dear customer, your order is ready.</p><p>Your ordered items are wainting for you at [personal].</p>",
  userCashierEmailOrderCompletedPostDelivery:
    "<p>Dear customer, your order is ready.</p><p>Your ordered items will be sent as soon as possible</p>",
  userCashierQRCodePayment: "Prepayment",
  // UTILS/HOWLONGAGO FUNCTION
  fHowLongAgoNow: "a few soconds ago",
  fHowLongAgoFewMinutes: "a few minutes ago",
  fHowLongAgoFewHours: "a few hours ago",
  fHowLongAgoFewDays: "a few days ago",
  fHowLongAgoYesterday: "yesterday",
  fHowLongAgoPrefix: "",
  fHowLongAgoMinSufix: " minutes ago",
  fHowLongAgoHourSufix: " hours ago",
  fHowLongAgoDaySufix: " days ago",
  // SETTINGSSUBMENU.VUE
  settingsSubMenuAllTitle: "Whole order",
  settingsSubMenuModulePhotoOrderTitle: "Photo order",
  settingsSubMenuModulePhotoGiftTitle: "Photo products",
  settingsSubMenuModuleGiftCardTitle: "Gift cards",
  settingsSubMenuModuleUserSettingsTitle: "User settings",
  settingsSubMenuModuleImageDatabasesTitle: "Image databases",
  settingsSubMenuModulePhotoOrderSubTitle:
    "Photo order module advanced settings",
  settingsSubMenuModuleUserSettingsSubTitle:
    "User settings module advanced settings",
  // SETTINGSDELIVERY.VUE
  settingsDeliveryGridHeaderDeliveryTitle: "Pickup place",
  settingsDeliveryGridHeaderPaymentTypesTitle: "Payment types",
  settingsDeliveryGridHeaderPaymentTypesShortTitle: "Payment",
  settingsDeliveryGridHeaderExtraPayTitle: "Extra charge",
  settingsDeliveryGridHeaderExtraPayMessageTitle: "Extra charge title",
  settingsDeliveryGridHeaderExtraPayFreeOverTitle: "No charge over",
  settingsDeliveryGridHeaderMinOrderTitle: "Minimal order amount",
  settingsDeliveryGridHeaderMapTitle: "Map",
  settingsDeliveryGridHeaderEmailTitle: "Email",
  settingsDeliveryGridHeaderShowAddressTitle: "Post",
  settingsDeliveryGridHeaderMapHint:
    "Paste direct link of the location (e.g. Google maps)",
  // SETTINGSPRODUCTSCATEGORY.VUE
  settingsProductsGridHeaderProductCategoryTitle: "Category",
  settingsProductsGridHeaderProductCategoryActiveTitle: "Active",
  // SETTINGSPRODUCTS.VUE
  settingsProductsGridHeaderNameTitle: "Title",
  settingsProductsGridHeaderImageTitle: "Image",
  settingsProductsGridHeaderDescriptionTitle: "Description",
  settingsProductsGridHeaderPriceTitle: "Price",
  settingsProductsGridHeaderhasFilesTitle: "Has files",
  settingsProductsGridHeaderCategoryTitle: "Category",
  settingsProductsGridHeaderSubCategoryTitle: "Options",
  settingsProductsGridHeaderSubCategoryHint:
    "Write an array of product options (comma separated)",
  // SETTINGSCOLOR.VUE
  settingsDeliveryPrimaryColorTitle: "Primary",
  settingsDeliverySecondaryColorTitle: "Secondary",
  settingsDeliveryAccentColorTitle: "Accent",
  // SETTINGSPHOTOORDERBASIC.VUE
  settingsPhotoOrderBasicSettingsTitle: "Basic",
  settingsPhotoOrderBasicApperanceTitle: "Apperance",
  settingsPhotoOrderBasicTaxTitle: "VAT (%)",
  settingsPhotoOrderBasicTitle: "Title",
  settingsPhotoOrderBasicSubTitle: "Subtitle",
  settingsPhotoOrderBasicImage: "Image (640x200px / jpg)",
  settingsPhotoOrderBasicWhiteText: "Light text",
  settingsPhotoOrderBasicEnableSimpleUploadTitle: "Enable upload of original images",
  settingsPhotoOrderBasicEnableDateTitle: "Enable adding dates on images",
  settingsPhotoOrderBasicEnableCropTitle: "Enable image cropping",
  settingsPhotoOrderBasicEnableAdvancedUploadTitle: "Enable advanced upload",
  settingsPhotoOrderBasicKeepOriginalFileNames:
    "Keep original file names",
  // SETTINGSIMAGESIZE.VUE
  settingsImageCustomSizeTitle: "Custom size image printed on",
  settingsImageSizeGridHeaderNameTitle: "Size",
  settingsImageSizeGridHeaderNameFileTitle: "Name (file)",
  settingsImageSizeGridHeaderPriceTitle: "Price",
  settingsImageSizeGridHeaderXTitle: "Width (px)",
  settingsImageSizeGridHeaderYTitle: "Height (px)",
  settingsImageSizePaperTypesTitle: "Paper",
  settingsImageSizeDefaultSizeTitle: "Default size selection",
  // SETTINGSIMAGEDISCOUNTS.VUE
  settingsImageDiscountsGridHeaderQuantityTitle: "Quantity",
  settingsImageDiscountsGridHeaderDiscountTitle: "Discount",
  // SETTINGSUSERRIGHTS.VUE
  settingsUserRightsisModerator: "Moderator",
  settingsUserRightsisAdmin: "Administrator",
  settingsUserRightsisSuperAdmin: "Super administrator",
  settingsUserRightsisSuperAdminCardTitle: "User",
  settingsUserRightsisSuperAdminMsgNoEmail: "Email not found.",
  // SETTINGSOTHER.VUE
  settingsOtherOrderEnableQRCodeTitle: "Add QR code",
  settingsOtherOrderPrintFontTitle: "Font",
  settingsOtherOrderPrintFontSizeTitle: "Font size",
  settingsOtherOrderPrintMaxWidthTitle: "Page width (px)",
  settingsOtherThisMonthTitle: "This month",
  settingsOtherThisYearTitle: "This year",
  settingsOtherTodayTitle: "Today",
  settingsOtherBasicSettingsCardTitle: "Basic settings",
  settingsOtherEnvironmentSettingsCardTitle: "Environment settings",
  settingsOtherPrepaySettingsCardTitle: "Prepay settings",
  settingsOtherOrderPrintSettingsCardTitle: "Order print settings",
  settingsOtherResponseSettingsCardTitle: "Response settings",
  settingsOtherLoginSettingsCardTitle: "Login settings",
  settingsOtherRulesAndSecurityInfoCardTitle: "Privacy policy and terms of use",
  settingsOtherShowCookiesInfoTitle: "Show cookies consent",
  settingsOtherShowPrivacyInfoTitle: "Show privacy policy agreement",
  settingsOtherShowRulesInfoTitle: "Show terms of use",
  settingsOtherPrivacyHTMLTitle: "Privacy policy",
  settingsOtherRulesHTMLTitle: "Terms of use",
  settingsOtherCookiesHTMLTitle: "Cookies",
  settingsOtherCurrencyCardTitle: "Currency",
  settingsOtherTaxTitle: "Tax title",
  settingsOtherNumberFormatTitle: "Number format",
  settingsOtherQRCodeFormatTitle: "QR code type",
  settingsOtherDigitsTitle: "Num. of digits",
  settingsOtherAutoResponseEmail: "Auto response email",
  settingsOtherDateFormatTitle: "Date format",
  settingsOtherLoginImageTitle: "Random login image",
  settingsOtherLoginImageKeywordTitle: "Login image category",
  settingsOtherLoginBackgroundWelcomeMessageTitle: "Welcome message",
  settingsOtherLoginBackgroundColorTitle: "Background color",
  settingsOtherLoginBackgroundImageTitle: "Random background category",
  settingsOtherLoginImageStorageLinkTitle:
    "Your login image (approx. 600x300px / jpg)",
  settingsOtherLogoImageStorageLinkTitle:
    "Your logo (max. 48x48px / square / .png)",
  settingsOtherLoginBackgroundImageKeywordTitle: "Image category",
  settingsOtherLoginBackgroundImageLinkTitle: "Background image link",
  settingsOtherLoginBackgroundShadowTypeTitle: "Back. shadow type",
  settingsOtherLoginBackgroundShadowStrengthTitle: "Back. shadow strength",
  settingsOtherFullNameTitle: "Store title",
  settingsOtherClientTitle: "Short name",
  settingsOtherCompanyInfoTitle: "Company info",
  settingsOtherCompanyInfoTitleTitle: "Company title",
  settingsOtherCompanyInfoAddress1Title: "Company address1",
  settingsOtherCompanyInfoAddress2Title: "Company address2",
  settingsOtherCompanyInfoAccountTitle: "Account",
  settingsOtherActiveTitle: "Active",
  settingsOtherVisibleTitle: "Visible",
  settingsOtherPricingTitle: "Subscription",
  settingsOtherBasePriceTitle: "Base subscription",
  settingsOtherBaseLimitTitle: "Included amout",
  settingsOtherOverLimitPctTitle: "Over included amount (%)",
  settingsOtherSubCalcTitle: "Subscription amount",
  settingsOtherCompanyInfoHintTitle:
    "Enter data for the head of prepay document...",
  settingsOtherClientPunchlineTitle: "Punchline",
  settingsOtherLangTitle: "Default language",
  settingsOtherThemeTitle: "Theme",
  settingsOtherThemeLightTitle: "Light",
  settingsOtherThemeDarkTitle: "Dark",
  settingsOtherCartExpireResponse:
    "<p>Hi, you have some open orders in the cart of our app. If you wish for your order to be completed, you have to go to the cart and click the Cashier button.</p><p>If you leave your cart items open, they will be removed in 2 days.</p><p>Thank you.</p>",
  settingsOtherCartExpireResponseTitle: "Open order notification",
  settingsOtherNewOrderMsgTitle: "New order notification",
  settingsOtherNewOrderPrepayMsgTitle: "New prepay order notification [email]",
  settingsOtherOrderCompletedPersonalTitle:
    "Order completed notification (personal delivery) [personal]",
  settingsOtherOrderCompletedPostTitle:
    "Order completed notification (post delivery)",
  // SETTINGSPROMOCODES.VUE
  settingsPromoCodesGridHeaderModuleTitle: "Module",
  settingsPromoCodesGridHeaderValidFromTitle: "Valid from",
  settingsPromoCodesGridHeaderValidToTitle: "Valid to",
  settingsPromoCodesGridHeaderPromoCodeTitle: "Promo code",
  settingsPromoCodesGridHeaderDiscountTitle: "Discont",
  settingsPromoCodesGridHeaderDiscountTypeTitle: "Discount type",
  settingsPromoCodesGridHeaderDiscountedItemTitle: "Discounted item ID",
  settingsPromoCodesGridHeaderDiscountedItemMainTitle: "Item discount",
  settingsPromoCodesGridHeaderDiscountedSubItemTitle: "Discounted sub item ID",
  settingsPromoCodesGridHeaderDiscountedSubItemMainTitle: "Sub item discount",
  settingsPromoCodesGridHeaderDiscountedSuperCategoryTitle:
    "Discounted super category ID",
  settingsPromoCodesGridHeaderDiscountedSuperCategoryMainTitle:
    "Super category discount",
  settingsPromoCodesGridHeaderDiscountedCategoryTitle: "Discounted category ID",
  settingsPromoCodesGridHeaderDiscountedCategoryMainTitle: "Subcategory discount",
  settingsPromoCodesGridHeaderHiddenTitle: "Hidden",
  settingsPromoCodesGridHeaderPermanentTitle: "Permanent",
  settingsPromoCodesDeleteOldInfoTitle:
    "Inactive promo codes, older than one month will be deleted automatically.",
  settingsPromoCodesDiscountedTypePct: "Percent (%)",
  settingsPromoCodesDiscountedTypeAmt: "Amount",
  // SETTINGSPAPERTYPE.VUE
  settingsPaperTypeGridHeaderPaperTypeTitle: "Paper type",
  settingsPaperTypeGridHeaderPaperTypeFileTitle: "Title (file)",
  settingsPaperTypeGridHeaderPriceTitle: "Extra charge",
  settingsPaperTypeGridHeaderDefaultTitle: "Default",
  settingsPaperTypeGridHeaderActiveTitle: "Active",
  // SETTINGSIMAGETEMPATE.VUE
  settingsImageTemplateBackMenuTypeNoneTitle: "No background layer",
  settingsImageTemplateOverlayMenuTypeNoneTitle: "No overlay layer",
  settingsImageTemplateMiddleMenuTypeNoneTitle: "No middle layer",
  settingsImageTemplateCurrentItemTitle: "element settings",
  settingsImageTemplateBackTitle: "background layer",
  settingsImageTemplateImageTitle: "middle layer",
  settingsImageTemplateMiddleTitle: "overlay layer",
  settingsImageTemplateEditTitle: "user layer",
  settingsImageTemplateOverlayTitle: "clipping layer",
  settingsImageTemplateBackTypeNone: "None",
  settingsImageTemplateBackTypeImage: "Image",
  settingsImageTemplateBackTypePattern: "Pattern",
  settingsImageTemplateBackTypeColor: "Color",
  settingsImageTemplateGHPermissionsTitle: "Permissions",
  settingsImageTemplateGHAllowTransparentBackTitle:
    "Allow transparent background",
  settingsImageTemplateGHAllowBackgroundTitle: "Allow custom background",
  settingsImageTemplateGHMainImageBackgroundTitle:
    "Backgroud image is not main image",
  settingsImageTemplateGHAllowImagesTitle: "Allow adding images",
  settingsImageTemplateGHAllowTextTitle: "Allow adding text",
  settingsImageTemplateGHAllowFreeDrawingTitle: "Allow free drawing",
  settingsImageTemplateGHAllowStickersTitle: "Allow adding stickers",
  settingsImageTemplateGridHeaderPrivateTitle: "Private",
  settingsImageTemplateGridHeaderLanguageTitle: "Language",
  settingsImageTemplateGridHeaderOrderTitle: "Order number",
  settingsImageTemplateGridHeaderCodeTitle: "Code",
  settingsImageTemplateGridHeaderTitleTitle: "Title",
  settingsImageTemplateGridHeaderWidthTitle: "Template width",
  settingsImageTemplateGridHeaderHeightTitle: "Template height",
  settingsImageTemplateGridHeaderDescriptionTitle: "Description",
  settingsImageTemplateGridHeaderInstructionsTitle: "Template instructions",
  settingsImageTemplateKeywordsTitle: "Subcategory",
  settingsImageTemplateGridHeaderModuleTitle: "Module",
  settingsImageTemplateGridHeaderActiveTitle: "Active",
  settingsImageTemplateGridHeaderCreatedTimestampTitle: "Created",
  settingsImageTemplateGridHeaderEditedTimestampTitle: "Last edit",
  settingsImageTemplateGridHeaderPreviewImageTitle:
    "Preview image approx. 600x300px (jpg/png)",
  settingsImageTemplateGridHeaderAllowAutoPreviewTitle:
    "Automatic preview image",
  settingsImageTemplateGridHeaderPreviewImageShortTitle: "Preview image",
  settingsImageTemplateGridHeaderRulesTitle: "Template definition",
  settingsImageTemplateGridHeaderRulesHint:
    "template definition for advanced users",
  settingsImageTemplateGridHeaderImageBgTitle: "Background template (jpg/png)",
  settingsImageTemplateGridHeaderImageBgShortTitle: "Background image",
  settingsImageTemplateGridHeaderImageFgTitle: "Foreground template (jpg/png)",
  settingsImageTemplateGridHeaderImageFgShortTitle: "Overlay image",
  settingsImageTemplateNoImageTitle: "No image",
  settingsImageTemplateEditRulesTemplateBtnTitle: "Edit template",
  settingsImageTemplateErrorWrongDimensions:
    "Wrong image template dimensions. You can edit dimensions in Template definition (eg. 1200x900).",
  // SETTINGSIMAGEDATABASE.VUE
  settingsImageDatabaseOrderTitle: "Order number",
  settingsImageDatabaseNameTitle: "Title",
  settingsImageDatabaseModuleTitle: "Module",
  settingsImageDatabaseActiveTitle: "Active",
  settingsImageDatabaseOwnerTitle: "Owner",
  settingsImageDatabaseRotateTitle: "Rotatable",
  settingsImageDatabaseCategoryTitle: "Category",
  settingsImageDatabaseKeywordsTitle: "Keywords",
  settingsImageDatabaseKeywordsHintTitle: "Comma separated keywords",
  settingsImageDatabaseImageTitle: "Image",
  settingsImageDatabaseImageBatchTitle: "One or more images",
  settingsImageDatabaseLanguageTitle: "Languange",
  settingsImageDatabaseDuplicateNameError: "Duplicate category name!",
  settingsImageDatabasePropertiesTitle: "Image properties",
  // SETTINGSIMAGEDATABASECATEGORY.VUE
  settingsImageDatabaseCategoryOrderTitle: "Order number",
  settingsImageDatabaseCategoryNameTitle: "Title",
  settingsImageDatabaseCategoryModuleTitle: "Module",
  settingsImageDatabaseCategoryActiveTitle: "Active",
  settingsImageDatabaseCategoryOwnerTitle: "Owner",
  // SETTINGSGIFTCARDTEMPLATE.VUE
  settingsGiftCardTemplateValidTitle: "Valid",
  settingsGiftCardTemplateValidMonth: "1 month",
  settingsGiftCardTemplateValidTwoMonths: "2 months",
  settingsGiftCardTemplateValidThreeMonths: "3 months",
  settingsGiftCardTemplateValidSixMonths: "6 months",
  settingsGiftCardTemplateValidYear: "1 year",
  settingsGiftCardTemplateValid2Years: "2 years",
  settingsGiftCardTemplateValid4Years: "3 years",
  settingsGiftCardTemplateValidInfinite: "Infinite",
  // SETTINGSPHOTOGIFTCATEGORY.VUE
  settingsPhotoGiftCategoryOrderTitle: "Order number",
  settingsPhotoGiftCategoryIdTitle: "Id",
  settingsPhotoGiftSuperCategoryTitle: "Category",
  settingsPhotoGiftCategoryNameTitle: "Title",
  settingsPhotoGiftCategoryImageTitle: "Image approx. 600x300px (jpg/png)",
  settingsPhotoGiftCategoryDescriptionTitle: "Description",
  settingsPhotoGiftCategoryActiveTitle: "Active",
  settingsPhotoGiftCategoryStepperStep1Title: "Select category",
  settingsPhotoGiftCategoryStepperStep2Title: "Select item",
  settingsPhotoGiftCategoryStepperStep3Title: "Select template",
  settingsPhotoGiftCategoryStepperStep4Title: "Edit item",
  settingsPhotoGiftCategoryStepperStep5Title: "Upload",
  // SETTINGSPHOTOGIFTSUPERCATEGORY.VUE
  settingsPhotoGiftSuperCategoryOrderTitle: "Order number",
  settingsPhotoGiftSuperCategoryTitleTitle: "Title",
  settingsPhotoGiftSuperCategoryIdTitle: "Id",
  settingsPhotoGiftSuperCategorySubTitleTitle: "Subtitle",
  settingsPhotoGiftSuperCategoryImageTitle: "Image 800x250px (jpg)",
  settingsPhotoGiftSuperCategoryWhiteTextTitle: "White text",
  settingsPhotoGiftSuperCategoryActiveTitle: "Active",
  // SETTINGSPHOTOGIFT.VUE
  settingsPhotoGiftSuperTypeTitle: "Type",
  settingsPhotoGiftSuperTypeItemTitle: "Item",
  settingsPhotoGiftSuperTypeGiftTitle: "Photo item",
  settingsPhotoGiftSuperTypeCollageTitle: "Photo collage",
  settingsPhotoGiftSuperTypeCustomTitle: "Custom size",
  settingsPhotoGiftSuperTypeGiftCardTitle: "Gift card",
  settingsPhotoGiftSuperTypeLargePrintTitle: "Large print",
  settingsPhotoGiftSuperTypePhotoCanvasTitle: "Photo canvas",
  settingsPhotoGiftMinOrderShortTitle: "min.",
  settingsPhotoGiftMinOrderTitle: "Min. order",
  settingsPhotoGiftMinTemplateClonesTitle: "Min. copies",
  settingsPhotoGiftMaxTemplateClonesTitle: "Max. copies",
  settingsPhotoGiftAllowTemplateClonesTitle: "Allow multiple copies",
  settingsPhotoGiftSkipEditTitle: "Skip edit",
  settingsPhotoGiftValidToTitle: "Valid to",
  settingsPhotoGiftAllowCustomSizeTitle: "Allow custom size",
  settingsPhotoGiftOverrideSizeTitle: "Override template size",
  settingsPhotoGiftOverrideSizeWidthTitle: "Width (px)",
  settingsPhotoGiftOverrideSizeHeightTitle: "Height (px)",
  settingsPhotoGiftEnableSmallDevicesTitle: "Enable on small devices",
  settingsPhotoGiftEnableSmallDevicesShortTitle: "Small devices",
  settingsPhotoGiftEnableDeviceBasedEdit:
    "Enable restricted edit options based on users device",
  settingsPhotoGiftEnableDeviceBasedEditShort: "Restricted edit",
  settingsPhotoGiftAddingExtraTemplateClonesTitle: "Allow additional copies",
  settingsPhotoGiftSendExtraEmailOnOrderTitle: "Send extra emails on order",
  settingsPhotoGiftOrderTitle: "Order number",
  settingsPhotoGiftCodesTitle: "Linked codes, separated with |",
  settingsPhotoGiftNameTitle: "Title",
  settingsPhotoGiftDescriptionTitle: "Description",
  settingsPhotoGiftIdTitle: "ID",
  settingsPhotoGiftImageTitle: "Image approx. 600x300px (jpg/png)",
  settingsPhotoGiftImageTypeTitle: "Image (square) max. 200x200px (jpg/png)",
  settingsPhotoGiftImageSizeTitle: "Gift preview image",
  settingsPhotoGiftActiveTitle: "Active",
  settingsPhotoGiftCategoryTitle: "Category",
  settingsPhotoGiftPriceTitle: "Price",
  settingsPhotoGiftKeywordsTitle: "Subcategories",
  settingsPhotoGiftInventoryTitle: "Inventory",
  settingsPhotoGiftTypeTitle: "Types",
  settingsPhotoGiftPrintSizeTitle: "Connected templates",
  settingsPhotoGiftType2Title: "Type",
  settingsPhotoGiftCopiesTitle: "Num. of items",
  settingsPhotoGiftSelectPhotoTitle: "Select photo",
  settingsPhotoGiftDetailsTitle: "Order details",
  settingsPhotoGiftUploadTitle: "Item order creation and adding to cart",
  settingsPhotoGiftFormNotCompleteErrorTitle:
    "Order form is not completed. Please ckeck if you selected all images and filled all the fields in the order form.",
  settingsPhotoGiftFormInventoryErrorTitle:
    "You've chosen more items than available in inventory. Current maximum order is",
  settingsPhotoGiftDefaultTemplateTitle: "Edit template",
  settingsPhotoGiftPreviewImageCoodrinatesTitle: "Preview image position",
  // USERSETTINGS.VUE
  userSettingsPermissionsTitle: "Permissions",
  userSettingsAdminTitle: "Administration",
  userSettingsAdminShowPackagesTitle: "Show packages",
  userSettingsAdminSendNewPackageMessageTitle: "Notifications of new packages",
  userSettingsallowFCMOrderNotificationTitle:
    "Allow notifications on this device",
  userSettingsallowFCMPromoNotificationTitle:
    "Direct notifications about promotions",
  userSettingsallowEmailOrderNotificationTitle: "Send email about my orders",
  userSettingsallowEmailPromoNotificationTitle: "Send email about promotions",
  userSettingsPersonalInfoTitle: "Personal info",
  userSettingsCompanyInfoTitle: "Company info",
  userSettingsIsCompanyTitle: "Business invoice",
  userSettingsVatNumberTitle: "VAT registration number",
  userSettingsFullNameTitle: "Full name",
  userSettingsAddress1Title: "Address 1",
  userSettingsAddress2Title: "Address 2",
  userSettingsCountryTitle: "Country",
  userSettingsPhoneTitle: "Phone num.",
  userSettingsEmailTitle: "Email",
  userSettingsCompanyFullNameTitle: "Company name",
  userSettingsCompanyAddress1Title: "Company address",
  // USERGIFTNEWORDER.VUE
  userGiftNewOrderCropButtonTitle: "Crop again",
  userGiftNewOrderSaveButtonTitle: "Crop",
  // USERNEWORDER.VUE
  userNewOrderSelectPhotosCardTitle: "Select photos",
  userNewOrderDefaultSettingsCardTitle: "Default settings",
  userNewOrderDefaultSettingsCardSubTitle:
    "First select size and other image properties from Default settings above. Then click in the Select photos field to select photos from your device. Selected photos will be added to your order with selected properties. Click Next button if you are satisfied with your selection. If you want to add more images with different properties (different size, paper type etc.), modify Default settings and click Select photos field again to add more images to your order. When you're done, click Next button.",
  userNewOrderDefaultSettingsCardSubTitle2:
    "On the next page (image preview) you will be able to adjust image settings individualy.",
  userNewOrderAddToCartHelp:
    "Adding to cart converts selected photos to a package and uploads it to the server. We will not charge you anything in this step. You can view your packages in Cart on the first page, and there you will finalize your order. Tip: you can add unlimited amount of packages and you are not bound to only one device. Simply open this app in the browser of any mobile phone, tablet or computer of any brand and upload additional packages. Then you can finalize your order and send all your pictures from all your devices in one go.",
  userNewOrderImageSizeSelectTitle: "Size",
  userNewOrderPaperTypeSelectTitle: "Paper",
  userNewOrderImageSelectPhotosHintTitle: "Add photos to the order",
  userNewOrderImageFillTypeTitle: "Print cropping mode",
  userNewOrderImageFillType1Title: "Fill-IN",
  userNewOrderImageFillType2Title: "Fit-IN",
  userNewOrderImageCropTitle: "Crop",
  userNewOrderImageEditTitle: "Edit",
  userNewOrderImageBorderTitle: "Add white border",
  userNewOrderImageDateTitle: "Print date",
  userNewOrderAutoCorrectionTitle: "Autocorrection",
  userNewOrderImageBorderShortTitle: "Border",
  userNewOrderImageDateShortTitle: "Date",
  userNewOrderAutoCorrectionShortTitle: "ACorr.",
  userNewOrderBtnAddMoreTitle: "Add",
  userNewOrderPreviewDialogTitle: "Rendering preview pictures",
  userNewOrderStepperStep1Title: "Selection",
  userNewOrderStepperStep2Title: "Editing",
  userNewOrderStepperStep3Title: "Summary",
  userNewOrderStepperStep4Title: "Upload",
  userNewOrderSummary1Title: "Package summary",
  userNewOrderSummary1aTitle: "Total images",
  userNewOrderSummary2Title: "Package price",
  userNewOrderSummary3Title: "Quantity discount",
  userNewOrderSummary4Title: "Price with quantity discount",
  userNewOrderSummary5Title: "Promo discount",
  userNewOrderSummary5cTitle: "Price with promo discount",
  userNewOrderSummary5dTitle: "Promo discount summary",
  userNewOrderSummary5aTitle: "Code",
  userNewOrderSummary5bTitle: "Valid for ",
  userNewOrderSummary5PromptTitle: "Promo code",
  userNewOrderSummary6Title: "Order price",
  userNewOrderSummaryExtraChargeTitle: "Price with extra charge",
  userNewOrderSummaryAddInfoTitle:
    "Additional costs and delivery charges will be applied on the cashier.",
  userNewOrderSummaryDeliveryTitle: "Delivery type",
  userNewOrderSummaryDeliveryPromptTitle: "Select delivery type",
  userNewOrderSummaryStudioInfoTitle: "Have a message for us?",
  userNewOrderPreparingPackageTitle: "Preparing package for upload",
  userNewOrderPleaseWaitTitle: "Please wait",
  userNewOrderOrderSending1Title: "Uploading package",
  userNewOrderOrderSending2Title:
    "Please dont't close the application until the package is uploaded",
  userNewOrderOrderComplete1Title:
    "If you want to send your packages to production, you have to select CASHIER button in the cart to select your delivery and type of payment.",
  userNewOrderOrderComplete2Title: "Package was added to cart",
  userNewOrderOrderCompleteGiftCardTitle: "Gift card was added to cart",
  userNewOrderNoPaperTypeForSelectedFormat:
    "Selected paper is not available for this print size. Please select different paper.",
  userNewOrderNoPaperTypeForSelectedFormatShort: "Select paper",
  userNewOrderNumOfErrors: "Number of errors: ",
  userNewOrderPaperTypeExtraPay: "Extra charge: ",
  userNewOrderPaperTypeNoExtraPay: "Paper",
  userNewOrderPcsHint: "Copies",
  userNewOrderFillInHint: "Crop",
  userNewOrderImageSizeHint: "Size",
  userNewOrderPreviewTitle: "Image preview",
  userNewOrderImageTitle: "Image",
  // USERNEWPHOTOGIFTORDER.VUE
  userNewPhotoGiftOrderCropTitle: "Crop image",
  userNewPhotoGiftOrderSelectTypeTitle: "Select item type",
  userNewPhotoGiftOrderLoadingMiddleImage: "Loading upper image layer",
  userNewPhotoGiftOrderLoadingOverlayImage: "Loading overlay image layer",
  userNewPhotoGiftOrderLoadingBackgroundImage: "Loading background image layer",
  userNewPhotoGiftOrderLoadingTemplateImage: "Loading template image",
  userNewPhotoGiftOrderLoadingTemplateImages: "Loading template images",
  userNewPhotoGiftOrderLoadingSimpleTemplateImage: "Loading simple image",
  userNewPhotoGiftOrderLoadingText: "Loading template text",
  userNewPhotoGiftOrderLoadingStickers: "Loading template stickers",
  userNewPhotoGiftOrderLoadingError:
    "Error while loading template. Press reset button to reload.",
  userNewPhotoGiftOrderLoadingImageError:
    "Error while loading image. Please try again.",
  userNewPhotoGiftOrderLoadingSuccess:
    "Template loaded. You can start editing.",
  userNewPhotoGiftOrderFinalizeError:
    "There are unfinished templates remaining, please review your order.",
  userNewPhotoGiftOrderDesignMaxCanvasError1:
    "Due to the size of this template you are able to add only single image to the design.",
  userNewPhotoGiftOrderDesignMaxCanvasError2:
    "Due to the size of this template there could be problems with designing this template. In that case, try to design this item on a more powerfull device. Thank you.",
  // VUECROPPER
  vueCropperHighQuality: "High quality image",
  vueCropperMiddleQuality: "Middle quality image",
  vueCropperLowQuality: "Nizka kakovost slike",
  vueCropperVeryLowQuality: "Zelo nizka kakovost slike",
  // USERNEWPHOTOGIFTORDERDESIGN.VUE
  userNewPhotoGiftOrderDesignTitle: "Product design",
  userNewPhotoGiftOrderDesignResetQuestion:
    "Reset current template to the initial value?",
  userNewPhotoGiftOrderDesignItemPreview: "On the item",
  userNewPhotoGiftOrderDesignInstructions: "Help",
  userNewPhotoGiftOrderDesignFinalize: "Finalize",
  userNewPhotoGiftOrderDesignMultiple: "Add new",
  userNewPhotoGiftOrderDesignReEdit: "Edit again",
  userNewPhotoGiftOrderDesignChangeTabQuestion:
    "Are you done editing current template?",
  userNewPhotoGiftOrderDesignFinalizeQuestion:
    "Do you want to finalize your order?",
  userNewPhotoGiftOrderDesignFinalizeMultipleQuestion:
    "Do you want to add and edit another item of this kind or finalize your order?",
  userNewPhotoGiftOrderDesignFinalizeMultipleToGo:
    "To complete this product you have to add",
  userNewPhotoGiftOrderDesignFinalizeMultipleToGoEnd:
    "Your product is ready to finalize.",
  userNewPhotoGiftOrderDesignFinalizeMultipleBtn1: "Back",
  userNewPhotoGiftOrderDesignFinalizeMultipleBtn2: "Add new item",
  userNewPhotoGiftOrderDesignFinalizeMultipleBody: "Current items",
  userNewPhotoGiftOrderDesignFinalizeMultipleBtn3: "Finalize all",
  userNewPhotoGiftOrderDesignSimpleError:
    "Template is not filled properly. Please fill the missing images.",
  userNewPhotoGiftOrderDesignSimpleError2:
    "Template is empty. Please add at least one image or some other element.",
  userNewPhotoGiftOrderDesignSwipeInfo:
    "To edit next template swipe left. Swiping is allowed anywhere on the screen except over the template.",
  userNewPhotoGiftOrderDesignSwipeRightError:
    "You are already editing first template.",
  // USERNEWPHOTOGIFTORDERFINALIZE.VUE
  userNewPhotoGiftOrderFinalizeTitle: "Order details",
  userNewPhotoGiftOrderFinalizeFormError:
    "Please set all of the required form fields before placing your order.",
  // USERNEWORDERBASIC.VUE
  userNewOrderBasicChangeSettings: "Change settings",
  userNewOrderBasicOrderCompleted: "Uploading complete",
  userNewOrderBasicBtnCancelOrder: "Cancel order",
  userNewOrderBasicNewPackage: "New package",
  userNewOrderBasicNotCroppedImages:
    "images are not cropped yet. You can send uncropped images and images will be cropped in studio.",
  userNewOrderBasicBtnAdd: "Add",
  userNewOrderBasicBtnUpload: "Send",
  userNewOrderBasicMainTitle: "New package",
  userNewOrderBasicSelectFormatInfo:
    "Changing image size removes existing crop and other effects.",
  userNewOrderBasicSelectDateInfo:
    "Changing date removes existing crop and other effects. Continue anyway?",
  userNewOrderBasicMainMenuTitle: "Add settings",
  userNewOrderBasicInitial1: "Click here to add images.",
  userNewOrderBasicInitial2: "Current selection is",
  userNewOrderBasicInitial3: "You can adjust image properties below.",
  userNewOrderBasicSettingsTitle: "Order settings",
  userNewOrderBasicSettingsHelp1Title:
    "First customize adding settings, then select your preferred package creation type below.",
  userNewOrderBasicSingleEditTitle: "Crop image",
  userNewOrderBasicSimpleUploadTitle: "Click here to send original images",
  userNewOrderBasicSimpleUploadDetail1Title:
    "for professional photos and  maximum quality",
  userNewOrderBasicSimpleUploadDetail2Title:
    "large package size, longer upload",
  userNewOrderBasicSimpleUploadDetail3Title: "no preview and cropping",
  userNewOrderBasicAdvancedUploadTitle: "Click here to send prepared images",
  userNewOrderBasicAdvancedUploadDetail0Title:
    "for ordinary photos from phones and other devices",
  userNewOrderBasicAdvancedUploadDetail1Title:
    "preview, cropping and editing images",
  userNewOrderBasicAdvancedUploadDetail2Title:
    "small package size, shorter upload",
  userNewOrderBasicSettingsHelpTitle:
    "I don't understand the advanced settings",
  userNewOrderBasicOldWarningTitle: "How many images can be sent per package?",
  userNewOrderBasicOldWarning:
    "Some older devices have less available memory and others may limit their memory for web browsers. Therefore sometimes large number of images can't be added in one package.",
  userNewOrderBasicOldWarning2:
    "If you experience this problem, please select fewer images per package (approx. 100-300) and send multiple packages instead.",
  userNewOrderBasicOldWarning3: "Thank you.",
  userNewOrderBasicGoBack: "Are you sure you want to cancel this order?",
  userNewOrderBasicGoBack2:
    "Are you sure you want to cancel this order and go back to main screen?",
  userNewOrderBasicGoUpload:
    "You are about to close this package and transfer images to server. Proceed?",
  userNewOrderBasicPackageFull:
    "Package is full. If you want to add more images, please upload this package, and then create new package.",
  userNewOrderBasicSingleSettingsTitle: "Image settings",
  userNewOrderBasicSettingsHelpFillInTitle: "Image FILL-IN / FIT-IN",
  userNewOrderBasicSettingsHelpFillIn:
    "Most images are made in FILL-IN mode, meaning that selected image format is filled, and portion of the image will be cropped. If by cropping we would loose valuable portions (like persons), we will print your image in FIT-IN mode.",
  userNewOrderBasicSettingsHelpDate:
    "Date is printed in the middle of the longer image border. Some images my not contain date info, and therefore date dannot be printed. Also some image apps overwrite the origianl date, so printed date may not be the date when the image was taken.",
  userNewOrderBasicSettingsHelpBR:
    "Thin white border around the image. Used often for invitations or greeting cards.",
  userNewOrderBasicSettingsHelpAC:
    "Autocorrection helps improve your image lighting and sharpeness, so it is the preferred choice for your photos. On the other hand, for images, which have been taken, edited and prepared for print professionally, autocorrection should be disabled.",
  userNewOrderBasicDateOK: "Date correct?",
  userNewOrderBasicDateWarning: "Important! You have marked date printing on at least one photo. We recommend that you double-check each photo before sending if the date matches it, otherwise it is better to remove it, because once you upload the package to the server, the date cannot be changed.",
  userNewOrderBasicUploadEmptyWarning: "Some images could not be read by the application, so they will be removed from the package when loading.",
  userNewOrderBasicHeicConversion: "Advanced conversion",
  // COMMON NEW ORDER
  commonNewOrderZipGenerationError: "There was an error during package creation.",
  commonNewOrderAddRecordError: "There was an error during record creation.",
  commonNewOrderOrderAddToCartTitle: "Add to cart",
  commonNewOrderOrderFinalizeAllTitle: "Finalize all",
  commonNewOrderOrderEndShoppingTitle: "View cart",
  commonNewOrderOrderContinueShoppingTitle: "Continue shopping",
  //USERNEWORDERSELECT.VUE
  userNewOrderSelectType: "select type",
  userNewOrderSelectSimpleType: "Select & send",
  userNewOrderSelectSimpleTypeDesc:
    "Just select your images and send them. We take care of everything else.",
  userNewOrderSelectAdvancedType: "Select, edit & send",
  userNewOrderSelectAdvancedTypeDesc:
    "Preview and crop your images before sending. Photos will be developed exactly as you wanted them to be.",
  // APP UPDATE
  appUpdateDialogTitle: "Application update available",
  appUpdateDialogBody:
    "Your current application version is outdated. We reccomend you to update this app by clicking YES button below. Priporočamo, da s klikom na gumb DA posodobite aplikacijo. Update takes only a few seconds to complete.",
  // APP CONFIRMATIONS DIALOG
  appConfirmationsTitle: "Common terms of use",
  appConfirmationsPrivacyTitle: "I agree that some of my personal data is stored for order processing",
  appConfirmationsRulesTitle: "I agree with terms of business of this store",
  appConfirmationsCookiesTitle: "I agree that this app uses cookies for better user experience",
  // STATS VUE
  statsModeTitle: "Mode",
  statsModeDay: "Day",
  statsModeMonth: "Month",
  statsModeYear: "Year",
  statsTotalSum: "Total",
  statsSummaryTitle: "Summary",
  statsDevelopImagesTitle: "Photos",
  statsPhotoItemsTitle: "Items",
  statsExtraCostsTitle: "Extra costs",
  statsItemCopiesTitle: "Items",
  statsOrderNumTitle: "Orders",
  statsOrderNumCompany: "Bussiness orders",
  statsOrderNumPaymentCard: "Credit card payments",
  statsOrderNumPaymentDelivery: "Delivery payments",
  statsOrderNumPaymentPersonal: "Personal payments",
  statsOrderNumPaymentPrepay: "Prepay payments",
  statsOrderNumPost: "Post deliverys",
  statsOrderNumPromoCode: "Promo code orders",
  statsTotalCopies: "Copies",
  userNewOrderBasicBtnSkipFile: "Skip this file"
};
